module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5346_-_Pro-Natura_-_Moda_Masculina_-_Moda_Masculina_Infantil_-_Moda_Familia.4fd10fee.jpg";